import { createAsyncThunk } from '@reduxjs/toolkit';
import { physicianTargetListAnalysisService } from '../../services';

const getYearsOfExperience = createAsyncThunk(
    'targetList/getYearsOfExperience',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getYearsOfExperience(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getSpecialtiesData = createAsyncThunk(
    'targetList/getSpecialtiesData',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getSpecialtiesData(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getTopStatesByIndividuals = createAsyncThunk(
    'targetList/getTopStatesByIndividuals',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getTopStatesByIndividuals(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getRegionCount = createAsyncThunk(
    'targetList/getRegionCount',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getRegionCount(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDigitalVsNonDigitalAffinity = createAsyncThunk(
    'targetList/getDigitalVsNonDigitalAffinity',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getDigitalVsNonDigitalAffinity(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getAffinityBySegment = createAsyncThunk(
    'targetList/getAffinityBySegment',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getAffinityBySegment(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getPersonalPromotionChannelAffinity = createAsyncThunk(
    'targetList/getPersonalPromotionChannelAffinity',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getPersonalPromotionChannelAffinity(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDynamicTopicCounts = createAsyncThunk(
    'targetList/getDynamicTopicCounts',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getDynamicTopicCounts(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getBrandedUnbrandedCounts = createAsyncThunk(
    'targetList/getBrandedUnbrandedCounts',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getBrandedUnbrandedCounts(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDistributionExperience = createAsyncThunk(
    'targetList/getDistributionExperience',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getDistributionExperience(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getPeerPeerAffinityData = createAsyncThunk(
    'targetList/getPeerPeerAffinityData',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getPeerPeerAffinityData(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getContentAffinityKeywords = createAsyncThunk(
    'targetList/getContentAffinityKeywords',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getContentAffinityKeywords(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getVendorAffinity = createAsyncThunk(
    'targetList/getVendorAffinity',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getVendorAffinity(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getTotalPhysicians = createAsyncThunk(
    'targetList/getTotalPhysicians',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getTotalPhysicians(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDigitalChannelAffinity = createAsyncThunk(
    'targetList/getDigitalChannelAffinity',
    async (payload, ThunkAPI) => {
        try{
            const response = await physicianTargetListAnalysisService.getDigitalChannelAffinity(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

export {
    getYearsOfExperience,
    getSpecialtiesData,
    getTopStatesByIndividuals,
    getRegionCount,
    getDigitalVsNonDigitalAffinity,
    getAffinityBySegment,
    getPeerPeerAffinityData,
    getPersonalPromotionChannelAffinity,
    getBrandedUnbrandedCounts,
    getDistributionExperience,
    getDynamicTopicCounts,
    getContentAffinityKeywords,
    getVendorAffinity,
    getTotalPhysicians,
    getDigitalChannelAffinity
};